import { memo } from 'react';
import UnderlinesForMessage from './UnderlinesForMessage';
import useStore from 'store';
import { useMessageIdsToUnderline } from 'store/selectors/messages';
import { useIsDesktop } from 'v1/hooks/use-is-media-query';

const Underlines = memo(function UnderlineMessages({ srId }: { srId: string }) {
  const activeMessageId = useStore.useActiveMessageId();
  const activeSrId = useStore.useActiveSrId();
  const isDesktop = useIsDesktop();
  const messageIds = useMessageIdsToUnderline(srId);

  // Only show underlines for the active field (srId)
  if (activeSrId !== srId) return null;

  // Don't show underlines for mobile and tablet until we add UI for it
  if (!isDesktop) return null;

  return (
    <div className="underlines">
      {messageIds.map((messageId) => {
        return (
          <UnderlinesForMessage
            messageId={messageId}
            active={activeMessageId === messageId}
            srId={srId}
            key={messageId}
          />
        );
      })}
    </div>
  );
});

export default Underlines;
